module.exports = __webpack_public_path__ + "img/BCorp.ad8ad269.svg";